import { Globals } from "../CoreApp/Globals";

export function GetCurrentLanguage() {
  return Globals._stringMgr.GetCurrentLanguage();
}
